import * as React from "react";
import { buildCertificateBlob } from "../../lib/certificate/certificatePdf";
import * as styles from "./ModuleDetailPage.css";

export function CertificatePreview({
  heading,
  recipientName,
  courseTitle,
  completedAt,
  certificateNumber,
}: {
  heading: string;
  recipientName: string;
  courseTitle: string;
  completedAt: string;
  certificateNumber: string;
}) {
  const [url, setUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    const blob = buildCertificateBlob({
      recipientName,
      courseTitle,
      completedAt,
      certificateNumber,
      labels: heading.trim() ? { heading } : undefined,
    });
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [heading, recipientName, courseTitle, completedAt, certificateNumber]);

  if (!url) return null;
  return (
    <iframe
      title="Certificate preview"
      src={`${url}#toolbar=0&navpanes=0&scrollbar=0`}
      className={styles.certificatePreviewFrame}
    />
  );
}
